import { useEffect, useState } from "react";
import CartContext from "./CartContext";
import { sumBy } from "lodash";

const CartContextProvider = ({ children }) => {
  const [cart, setCart] = useState([]);
  const [people, setPeople] = useState(0);
  const [total, setTotal] = useState(0);

  const cartAction = (count, item) => {
    const isCartItem = cart.find((cart) => cart.id === item.id);

    if (isCartItem) {
      // console.log(true);
      // console.log(count);
      if (count === 0) {
        //console.log(count, item.id);
        setCart(cart.filter((cartItem) => cartItem.id !== item.id));
        localStorage.setItem(
          "LocalCart",
          JSON.stringify(cart.filter((cartItem) => cartItem.id !== item.id))
        );
      } else {
        setCart(
          cart.map((cartItem) =>
            cartItem.id === item.id
              ? {
                  ...item,
                  quantity: count,
                }
              : cartItem
          )
        );
        localStorage.setItem(
          "LocalCart",
          JSON.stringify(
            cart.map((cartItem) =>
              cartItem.id === item.id
                ? {
                    ...item,
                    quantity: count,
                  }
                : cartItem
            )
          )
        );
      }
    } else {
      if (count > 0) {
        setCart([
          ...cart,
          {
            ...item,
            quantity: count,
          },
        ]);
        localStorage.setItem(
          "LocalCart",
          JSON.stringify([
            ...cart,
            {
              ...item,
              quantity: count,
            },
          ])
        );
      }
    }
  };

  useEffect(() => {
    setCart(JSON.parse(localStorage.getItem("LocalCart")) || []);
  }, []);

  useEffect(() => {
    const getTotalPeople = () => {
      let people = sumBy(cart, function (n) {
        return n.quantity;
      });
      let fullTotal = sumBy(cart, function (n) {
        return n.subtotal;
      });
      setPeople(people);
      setTotal(fullTotal);
    };
    getTotalPeople();
  }, [cart]);

  return (
    <CartContext.Provider value={{ cartAction, cart, people, total }}>
      {children}
    </CartContext.Provider>
  );
};

export default CartContextProvider;
